module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (
    _vm.donation.formWizardCurrentStep === 0 && _vm.products && _vm.products.length > 0
  ) ? _c('div', {
    staticClass: "product-selector"
  }, _vm._l((_vm.products), function(p) {
    return _c('div', {
      staticClass: "product",
      class: {
        isActive: _vm.product && p.id == _vm.product.id
      },
      on: {
        "click": function($event) {
          _vm.select(p)
        }
      }
    }, [_vm._v("\n    " + _vm._s(_vm.getProductTypeMapping(p.producttype)) + "\n  ")])
  })) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b64632e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=csplt5ikear!./~/string-replace-webpack-plugin/loader.js?id=ja005zozwkc!./src/components/product/ProductSelector.vue
// module id = 674
// module chunks = 0